<template>
  <div class="row mx-0 shadow-sm mb-2 py-2 archiv-user-row" :class="backgroundColor">
    <div class="col my-auto">{{ user.benutzername }}</div>
    <div class="col my-auto">{{ user.username }}</div>
    <div class="col my-auto">{{ user.email }}</div>
  </div>
</template>

<script lang="ts" setup>
  //#region Imports
  import { PropType, computed } from 'vue';
  import { ArchivUser, Benutzer } from '@/models/AuthModels';
  //#endregion

  const { user, editBenutzer, benutzer } = defineProps({
    user: {
      type: Object as PropType<ArchivUser>,
      required: true,
    },

    editBenutzer: {
      type: Object as PropType<Benutzer>,
      required: true,
    },

    benutzer: {
      type: Array as PropType<Benutzer[]>,
      required: true,
    },
  });

  const backgroundColor = computed(() => {
    if (user.id === editBenutzer.identityUserId) {
      return 'selected-user-row';
    } else if (benutzer.some((b) => b.identityUserId === user.id)) {
      return 'existing-user-row';
    } else {
      return 'bg-white';
    }
  });
</script>

<style scoped lang="scss">
  .archiv-user-row {
    overflow-x: visible;
  }
  .archiv-user-row:hover {
    transform: scale(0.99, 1);
    cursor: pointer;
  }

  .selected-user-row {
    background-color: rgba(241, 168, 44, 0.4);
  }

  .existing-user-row {
    background-color: rgba(108, 117, 125, 0.4);
  }
</style>
